exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grading-table-row:not(:last-child) {\n  border-bottom-width: 1px;\n}\n.grading-table-question {\n  width: 33.33333%;\n  padding: 1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.grading-table-grades {\n  width: 66.66667%;\n  display: -ms-flexbox;\n  display: flex;\n}\n", ""]);

// exports
